// slice 02.1 · paso b.6d — capa de fondo del canvas de roadmap (`ComponentTaskFlow.jsx`): grid de
// puntos por día, sombreado de fines de semana, y la línea roja del "hoy". Presentacional puro:
// solo necesita `timeline` (ya calculado por el container) — importa `CANVAS_HEIGHT` directo de
// `lib/flowCanvas`, igual que el container, en vez de recibirlo por prop.

import { CANVAS_HEIGHT } from '../lib/flowCanvas';

export default function FlowGridLayer({ timeline }) {
    return (
        <svg
            className="op-task-flow-dots"
            xmlns="http://www.w3.org/2000/svg"
            width={timeline.CANVAS_WIDTH} height={CANVAS_HEIGHT}
        >
            <defs>
                <pattern id="op-task-day-pattern" x="0" y="0" width="200" height={CANVAS_HEIGHT} patternUnits="userSpaceOnUse">
                    <line x1="0" y1="0" x2="0" y2={CANVAS_HEIGHT} stroke="rgba(255, 255, 255, 0.15)" strokeWidth="1" />
                </pattern>
            </defs>
            <rect width={timeline.CANVAS_WIDTH} height={CANVAS_HEIGHT} fill="url(#op-task-day-pattern)" />

            {/* Weekend Highlights */}
            {timeline.days.filter(d => d.isWeekend).map(d => (
                <rect key={`we-${d.index}`} x={d.index * 200} y="0" width="200" height={CANVAS_HEIGHT} fill="rgba(255, 255, 255, 0.02)" />
            ))}

            {/* Red Line for Current Time */}
            <line x1={timeline.redLineX} y1="0" x2={timeline.redLineX} y2={CANVAS_HEIGHT} stroke="#ef4444" strokeWidth="2" strokeDasharray="4 4" />
            <circle cx={timeline.redLineX} cy="0" r="4" fill="#ef4444" />
        </svg>
    );
}
